import { render, staticRenderFns } from "./ys.vue?vue&type=template&id=2b1ef752&scoped=true"
import script from "./ys.vue?vue&type=script&lang=js"
export * from "./ys.vue?vue&type=script&lang=js"
import style0 from "./ys.vue?vue&type=style&index=0&id=2b1ef752&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1ef752",
  null
  
)

export default component.exports